import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import SessionAttendeeModal from '@activities/components/modals/session-attendee-modal/session-attendee-modal.vue';
import SessionsWeeklyCalendar from '@activities/components/calendars/sessions-weekly-calendar.vue';
import { EventApi } from '@fullcalendar/common';
import { Activity } from '@activities/interfaces/activity';
import PaymentCheckoutStatus from '@accounting/components/payment-checkout-status.vue';

@Component({
  components: {
    'bpc-session-attendee-modal': SessionAttendeeModal,
    'bpc-sessions-weekly-calendar': SessionsWeeklyCalendar,
    'bpc-payment-checkout-status': PaymentCheckoutStatus,
  },
})
export default class ActivitySessionsAttendees extends Vue {
  $refs: {
    activityDetailsSessionsWeeklyCalendar: InstanceType<typeof SessionsWeeklyCalendar> & {
      getAllSessionsOfTheWeek(): void;
    };
    profileActivitySessionsWeeklyCalendar: InstanceType<typeof SessionsWeeklyCalendar> & {
      getAllSessionsOfTheWeek(): void;
    };
  };
  // PROPS
  // DATA
  showSessionAttendeeModal = false;
  selectedSessionToAttend: number = null;
  isCheckoutConfirmation = false;
  confirmationPaymentSuccess = false;
  confirmationPaymentCancel = false;
  declare userIsLoggedIn: boolean;
  declare showModalLogin: boolean;
  declare activity: Activity;
  // COMPUTED
  get selectedActivityIdToAttend(): number {
    return this.activity?.id;
  }
  // LIFECYCLE
  created() {
    const step =
      this.$route.query['step'] ||
      this.$store.getters['shoppingCart/publicLayoutQueryParams']['step'];

    const status =
      this.$route.query['status'] ||
      this.$store.getters['shoppingCart/publicLayoutQueryParams']['status'];

    const success = status === 'success';
    const cancel = status === 'cancel';

    this.isCheckoutConfirmation = step === 'checkout-confirmation';

    this.confirmationPaymentSuccess = this.isCheckoutConfirmation && success;
    this.confirmationPaymentCancel = this.isCheckoutConfirmation && cancel;
  }
  // METHODS
  onSessionClicked(event: EventApi) {
    this.selectedSessionToAttend = Number(event.id);
    if (!this.userIsLoggedIn) {
      this.showModalLogin = true;
    } else {
      this.showSessionAttendeeModal = true;
    }
  }
  onCloseSessionAttendeeModal() {
    this.showSessionAttendeeModal = false;
    this.selectedSessionToAttend = null;
  }

  maybeContinueAttendeeModal() {
    if (this.activity.activity_type === 'session') {
      this.showSessionAttendeeModal = true;
    }
  }

  onAttendeesPaid() {
    if (this.$refs.activityDetailsSessionsWeeklyCalendar) {
      this.$refs.activityDetailsSessionsWeeklyCalendar.getAllSessionsOfTheWeek();
    }
    if (this.$refs.profileActivitySessionsWeeklyCalendar) {
      this.$refs.profileActivitySessionsWeeklyCalendar.getAllSessionsOfTheWeek();
    }
  }

  restartPayment(e) {
    console.log('restart-payment', e);
  }

  public onCreateAttendee(): void {
    // this.provisionalActivityGroup = activityGroup;
    // this.validationErrorsToEnroll = [];
    // this.showValidationErrorsToEnroll = false;
    // if (!this.userIsLoggedIn) {
    //   this.showLoginModal();
    // } else {
    //   if (activityGroup) {
    //     this.$refs.confirmationModal.onOpenModal(activityGroup.id);
    //   }
    //   this.contactsToEnroll = [];
    // }
  }
  // WATCHERS
}
